import { useQueryParam } from '@psyomics/ui-common';
import { useLocation, useParams } from 'react-router-dom';

import { DirectLink as DirectLinkFeature } from '../../../features/direct-link';

const useEncodedParam = () => {
  const { search } = useLocation();
  const ivHex = useQueryParam('iv');
  const match = search.match(/\?([^&]+)/);

  return {
    param: match?.[1],
    ivHex,
  };
};

const DirectLink = () => {
  const { action } = useParams();
  const { param, ivHex } = useEncodedParam();

  if (!action || !param) throw Error('Invalid request');

  return <DirectLinkFeature action={action} ivHex={ivHex} param={param} />;
};

export { DirectLink };
